<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" ref="searchForm">
          <el-form-item label="SKU编码:">
            <el-input v-model.trim="searchForm.skuCode" placeholder="请输入SKU编码"></el-input>
          </el-form-item>
          <el-form-item label="SKU名称:">
            <el-input v-model.trim="searchForm.skuName" placeholder="请输入SKU名称"></el-input>
          </el-form-item>
          <el-form-item label="产品编码:">
            <el-input v-model.trim="searchForm.productCode" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model.trim="searchForm.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="套件编码:">
            <el-input v-model.trim="searchForm.suitCode" placeholder="请输入套件编码"></el-input>
          </el-form-item>
          <el-form-item label="套件名称:">
            <el-input v-model.trim="searchForm.suitName" placeholder="请输入套件名称"></el-input>
          </el-form-item>
          <el-form-item label="包件编码:">
            <el-input v-model.trim="searchForm.packCode" placeholder="请输入包件编码"></el-input>
          </el-form-item>
          <el-form-item label="包件名称:">
            <el-input v-model.trim="searchForm.packName" placeholder="请输入包件名称"></el-input>
          </el-form-item>
          <el-form-item label="是否清仓:">
            <el-select v-model="searchForm.clearance" placeholder="请选择">
              <el-option label="全部" value="">全部</el-option>
              <el-option label="是" value="是">是</el-option>
              <el-option label="否" value="否">否</el-option>
              <el-option label="-" value="-">-</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否成品:">
            <el-select v-model="searchForm.isFinishedProduct" placeholder="请选择">
              <el-option label="全部" value="">全部</el-option>
              <el-option label="是" :value="1">是</el-option>
              <el-option label="否" :value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否绑定SKU:">
            <el-select v-model="searchForm.skuBindFlag" placeholder="请选择">
              <el-option label="全部" value="全部">全部</el-option>
              <el-option label="是" value="是">是</el-option>
              <el-option label="否" value="否">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否组合:">
            <el-select v-model="searchForm.isCombination" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" @click="searchPage" size="mini">搜索</el-button>
          <el-button class="orange-btn" @click="resetForm" size="mini">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" class="green-btn" @click="exportExcel">导出</el-button>
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </template>

      <el-table
        v-loading="loading"
        @select="serlectRow"
        ref="table"
        :height="maxTableHeight"
        v-if="tableReload"
        border
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          :sortable="item.sortable ? 'custom' : false"
          :fixed="item.fixed"
          show-overflow-tooltip
          v-for="item in columnData"
          :key="item.prop"
        >
          <template slot-scope="scope">
            <template>
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </content-panel>
</template>

<script>
import { FILE_TYPE } from "@/utils/Global.js";
import customPropsMixin from "./customProps.mixin";
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
export default {
  name: "Hierarchy",
  mixins: [customPropsMixin, pagePathMixin, tableMixin],
  data() {
    return {
      titleName: "",
      showFlag: false,
      searchForm: {
        clearance: "",
        isFinishedProduct: "",
        skuBindFlag: "是",
        isCombination: "",
      },
      rules: {
        location: [{ required: true, message: "请选择商品定位", trigger: "blur" }],
      },
      requestParam: {},
      dialogFormVisible: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: "auto",
      optionTypes: [],
      loading: false,
      locations: [],
      tableReload: true,
      columnsData: [],
    };
  },
  computed: {},
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    searchPage() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      this.columns();
      let param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.$q.goods.hierarchyListPage({ data: JSON.stringify(param) }).then((res) => {
        this.tableData = res.data;
        this.loading = false;
      });
    },
    initSearchForm() {
      this.searchForm = { clearance: "", isFinishedProduct: "", skuBindFlag: "是", isCombination: "" };
    },
    resetForm() {
      this.initSearchForm();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-api",
          paramMap: {
            exportTag: true,
            ...this.searchForm,
          },
          reportName: "hierarchyExport",
        },
        columnDTOs: [],
      };
      let labels = this.columnData.map((v) => v.label);
      let props = this.columnData.map((v) => v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: "string",
          columnFormat: null,
        });
      });
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        console.log(res);
        loading.close();
        this.$message({
          type: "success",
          message: "导出成功,请在导出列表中查看",
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped></style>
